import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-affiliation',
  templateUrl: './affiliation.component.html',
  styleUrls: ['./affiliation.component.scss']
})
export class AffiliationComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
